import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth';
import { useState, useEffect } from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateAuth = async () => {
      try {
        // Check if token exists
        if (!authService.isAuthenticated()) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        // Validate token by trying to fetch user data
        await authService.getCurrentUser();
        setIsAuthenticated(true);
      } catch (error) {
        console.log('Authentication validation failed:', error);
        // Clear invalid token
        authService.clearAuthData();
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    validateAuth();
  }, []);

  if (isLoading) {
    return (
      <div className="page-theme-list">
        <div className="main-content">
          <div className="content-container">
            <div className="loading-state" style={{ 
              textAlign: 'center', 
              padding: '4rem 2rem',
              minHeight: '60vh',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <h2>🔐 Verifying authentication...</h2>
              <p>Please wait while we check your credentials.</p>
              <div style={{ 
                marginTop: '1rem',
                fontSize: '0.875rem',
                color: '#6b7280'
              }}>
                <span className="tamil tamil-accent">சுவடி</span> Suvadi - Digital Heritage
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};
